(function () {
    if (window.__pageScrollAnimation) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.pageScrollAnimation = window.Branch.pageScrollAnimation || {};
    window.Branch.pageScrollAnimation.userExperiences = window.Branch.pageScrollAnimation.userExperiences || {};

    window.__pageScrollAnimation = true;

    function onHomepageScroll(){
        console.log('onHomepageScroll')
        let lastThrottleTime = 0;
        const throttleDelay = 250;
        let debounceTimeout;
        const debounceDelay = 100;

        function isInOrAboveViewport(el) {
            const rect = el.getBoundingClientRect();
            return rect.top <= window.innerHeight;
        }

        function isElementVisible(el) {
            return el.offsetParent !== null;
        }

        function getMinVisibleHeightThreshold() {
            return window.innerWidth < 600 ? 60 : 80;
        }

        function isSectionEnoughInView(section) {
            const rect = section.getBoundingClientRect();
            const threshold = getMinVisibleHeightThreshold();
            const visibleAmount = window.innerHeight - rect.top;

            if (rect.top >= window.innerHeight) return false;
            if (visibleAmount <= threshold) return false;
            return true;
        }

    window.Branch.pageScrollAnimation.animateVisibleElements = function() {
        const allUnanimated = Array.from(
            document.querySelectorAll('[data-animate-slide-in="true"]:not([data-animated="true"])')
        );

        const sectionGroups = new Map();

        allUnanimated.forEach(el => {
            const section = el.closest('.shopify-section:not([data-section-animated="true"])');
            if (!section) return;

            if (!sectionGroups.has(section)) {
            sectionGroups.set(section, []);
            }

            sectionGroups.get(section).push(el);
        });


        sectionGroups.forEach((group, section) => {
            if (!isSectionEnoughInView(section)) return;

            const shouldAnimateGroup = group.some(el =>
            isElementVisible(el) && isInOrAboveViewport(el)
            );

            if (!shouldAnimateGroup) return;

            section.setAttribute('data-section-animated', 'true');

            const buckets = new Map();

            group.forEach(el => {
                const order = parseInt(el.getAttribute('data-cascade-order') || '0', 10);
                if (!buckets.has(order)) {
                    buckets.set(order, []);
                }
                buckets.get(order).push(el);
            });

            const sortedOrders = [...buckets.keys()].sort((a, b) => a - b);

            sortedOrders.forEach((order, pageScrollAnimation) => {
            const delay = pageScrollAnimation * 100;
            const elementsInBucket = buckets.get(order);

            elementsInBucket.forEach(el => {
                setTimeout(() => {
                    el.setAttribute('data-animated', 'true');
                }, delay);
            });
            });
        });
    }

    function onScroll() {
        const now = Date.now();
        if (now - lastThrottleTime > throttleDelay) {
            lastThrottleTime = now;
            window.Branch.pageScrollAnimation.animateVisibleElements();
        }

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            window.Branch.pageScrollAnimation.animateVisibleElements();
        }, debounceDelay);
    }

    window.Branch.pageScrollAnimation.animateVisibleElements();

    window.Branch.pageScrollAnimation.attachScrollEvent = function(){
            window.addEventListener('scroll', onScroll);
            window.addEventListener('scroll', function() {
                    window.Branch.nav.handleToggleHeaderScroll();
                }
            );
    }
    window.Branch.pageScrollAnimation.attachScrollEvent();
    }

    window.Branch.pageScrollAnimation.indexInitOnLoad = function(type){
        if(document.querySelector('body[data-scroll-animations-active="true"]')){
            onHomepageScroll();
        }
    }

    if (document.readyState === "complete") {
        window.Branch.pageScrollAnimation.indexInitOnLoad('regular'); 
    } else {
        window.addEventListener("DOMContentLoaded", () => window.Branch.pageScrollAnimation.indexInitOnLoad('regular'));
    }
  })();
